<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb />
      </div>
    </div>
    <b-card>
      <b-overlay :show="showLoading" rounded="sm">
        <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
          <h4 class="col-12 col-xl-2 mb-1 mb-xl-0 font-weight-bold">
            {{ isBranchProductList ? '分店商品列表' : '商品管理' }}
          </h4>
          <div
            class="
              col-12 col-xl-10
              d-flex
              flex-column flex-xl-row
              align-items-start align-items-xl-center justify-content-xl-end
            "
          >
            <b-button
              class="flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2"
              v-if="!isBranchProductList && checkPermission([consts.BRANCH_PRODUCT_SYNC])"
              @click="handleSyncAllBranchProduct"
              variant="primary"
            ><i class="mdi mdi-sync" aria-hidden="true"></i>同步所有商品至分店
            </b-button>
            <b-button
              class="flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2"
              v-if="checkPermission([consts.PRODUCT_IMPORT])"
              variant="primary"
              v-b-modal.modal-upload
            ><i class="mdi mdi-cloud-upload" aria-hidden="true"></i>商品匯入
            </b-button>
            <b-button
              class="flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2"
              v-if="checkPermission([consts.PRODUCT_IMPORT_MICHELIN])"
              variant="primary"
              v-b-modal.modal-upload-michelin
            ><i class="mdi mdi-cloud-upload" aria-hidden="true"></i>商品匯入 - 米其林
            </b-button>
            <b-button
              class="flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2"
              v-if="checkPermission([consts.PRODUCT_IMPORT_MICHELIN_MB])"
              variant="primary"
              v-b-modal.modal-upload-michelin-mb
            ><i class="mdi mdi-cloud-upload" aria-hidden="true"></i>商品匯入 - 米其林 - MB
            </b-button>
            <b-button
              class="flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2"
              v-if="checkPermission([consts.PRODUCT_CREATE]) && !isBranchProductList"
              variant="primary"
              :to="{
                name: 'ProductCreateV2',
                query: {merchant_id: this.query.merchant_id, is_branch_product: isBranchProductList},
              }"
            ><i class="fa fa-plus" aria-hidden="true"></i>新增商品
            </b-button>
            <b-button
              class="flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2"
              v-if="checkPermission([consts.BRANCH_PRODUCT_CREATE]) && isBranchProductList"
              variant="primary"
              :to="{
                name: 'ProductCreateV2',
                query: {
                  merchant_id: this.query.merchant_id,
                  branch_id: this.selectedBranch?.value === 'null' ? null : this.selectedBranch?.value,
                  is_branch_product: isBranchProductList
                },
              }"
            ><i class="fa fa-plus" aria-hidden="true"></i>新增分店商品
            </b-button>
            <b-button
              class="flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2"
              variant="primary"
              v-if="isBranchProductList && checkPermission([consts.BRANCH_PRODUCT_SINGLE_SYNC])"
              @click="handleSyncProductFromMain"
            > <i class="fa fa-rotate-right" aria-hidden="true"></i>同步商品
            </b-button>
            <b-button
              v-b-toggle.collapse-advanced-search
              variant="outline-info"
              class="mb-2 mb-xl-0"
              style="height: 34px;"
            >
              <span class="mdi mdi-magnify mt-1 mr-1"></span>進階搜尋
            </b-button>
          </div>
          <div class="col-12 mt-2">
            <b-collapse id="collapse-advanced-search" v-model="isAdvancedSearchVisible">
              <b-card>
                <b-form>
                  <div class="row mb-2">
                    <div class="col-12 col-xl-6 mb-2" v-if="isBranchProductList">
                      <div class="d-flex align-items-center">
                        <label class="filter-label mb-0 mr-2">分店</label>
                        <AppSingleSelect
                          id="branch-select"
                          class="advanced-search-control flex-grow-1"
                          v-model="selectedBranch"
                          :options="branchOptions"
                          :disabled="isBranchSelectDisabled"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xl-6 mb-2">
                      <div class="d-flex align-items-center">
                        <label class="filter-label mb-0 mr-2">類型</label>
                        <b-form-select
                          v-model="query.type"
                          class="advanced-search-control flex-grow-1"
                        >
                          <template #first>
                            <b-form-select-option :value="null">全部類型</b-form-select-option>
                          </template>
                          <b-form-select-option
                            v-for="productType in productTypes"
                            :key="productType.value"
                            :value="productType.value"
                          >
                            {{ productType.text }}
                          </b-form-select-option>
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6 mb-2">
                      <div class="d-flex align-items-center">
                        <label class="filter-label mb-0 mr-2">分類</label>
                        <b-form-select
                          v-model="query.category"
                          :options="productCategoryOptions"
                          class="advanced-search-control flex-grow-1"
                        ></b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6 mb-2">
                      <div class="d-flex align-items-center">
                        <label class="filter-label mb-0 mr-2">狀態</label>
                        <b-form-select
                          v-model="query.is_enabled"
                          :options="productStatusOptions"
                          class="advanced-search-control flex-grow-1"
                        ></b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6 mb-2">
                      <div class="d-flex align-items-center">
                        <label class="filter-label mb-0 mr-2">通路</label>
                        <b-form-select
                          v-model="query.merchant_id"
                          :options="merchants"
                          :disabled="merchants.length == 2"
                          class="advanced-search-control flex-grow-1"
                        ></b-form-select>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <b-button
                      variant="primary"
                      class="mr-2"
                      @click="resetAdvancedSearch"
                    >
                      <i class="mdi mdi-restart"></i> 重置條件
                    </b-button>
                    <b-button
                      variant="primary"
                      @click="handleSearchFromAdvanced"
                    >
                      <i class="fa fa-search"></i> 搜尋
                    </b-button>
                  </div>
                </b-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="col-12 mt-2">
            <b-card class="mb-0">
              <b-input-group>
                <b-form-input
                  placeholder="請輸入商品名稱或商品序號"
                  v-model="query.keyword"
                  v-on:keyup.enter="handleFiltersAreChanged"
                ></b-form-input>
                <b-input-group-append>
                  <b-button @click="handleFiltersAreChanged">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-card>
          </div>
        </div>
        <b-table class="product-list-table" responsive striped hover :items="products" :fields="fields">
          <template #cell(name)="data">
            <router-link
              :to="{
                name: 'ProductDetailV2',
                params: {
                  product_id: data.item.id,
                },
              }"
            >
              <div class="mb-1 text-truncate-cell" :id="`product-title-${data.item.id}`">
                {{ hiddenString(data.item.title, 50) }}
              </div>
              <b-popover
                v-if="data.item.title"
                :target="`product-title-${data.item.id}`"
                triggers="hover focus"
                placement="right"
              >
                <div class="text-left">{{ data.item.title }}</div>
              </b-popover>
              <div class="text-truncate-cell" :id="`product-code-${data.item.id}`">
                {{ hiddenString(data.item.product_code, 50) }}
              </div>
              <b-popover
                v-if="data.item.product_code"
                :target="`product-code-${data.item.id}`"
                triggers="hover focus"
                placement="right"
              >
                <div class="text-left">{{ data.item.product_code }}</div>
              </b-popover>
            </router-link>
          </template>
          <template #cell(picture)="data">
            <b-img-lazy
              v-if="data.item.images[0] && data.item.images[0].pic_url"
              class="thumb-image"
              :src="data.item.images[0] && data.item.images[0].pic_url"
              alt="商品圖片"
              width="50"
              height="50"
            />
          </template>
          <template #cell(started_at_and_end_at)="data">
            <div class="mb-1">
              {{ formatDate(data.item.available_start_at) }}
            </div>
            <div>{{ formatDate(data.item.available_end_at) }}</div>
          </template>
          <template #cell(type)="data">
            {{ getProductTypeText(data.item.type) }}
          </template>
          <template #cell(arrange)="data">

            <!-- <b-button
              class="ml-2"
              variant="inverse-primary"
              v-if="checkPermission([consts.PRODUCT_LIST_VIEW])"
              :to="{
                name: 'ProductDetail',
                params: {
                  product_id: data.item.id,
                },
              }"
              ><span class="mdi mdi-eye mr-1"></span>查看
            </b-button> -->
            <b-button
              class="ml-2"
              variant="inverse-primary"
              v-if="checkPermission([consts.PRODUCT_LIST_VIEW])"
              :to="{
                name: 'ProductDetailV2',
                params: {
                  product_id: data.item.id
                },
                query: {
                   is_branch_product: isBranchProductList
                }
              }"
            ><span class="mdi mdi-eye mr-1"></span>查看
            </b-button>
            <!-- <b-button
              class="ml-2"
              variant="inverse-warning"
              v-if="isBranchProductList ? checkPermission([consts.BRANCH_PRODUCT_MODIFY]) : checkPermission([consts.PRODUCT_MODIFY])"
              :to="{
                name: 'ProductEdit',
                params: {
                  product_id: data.item.id,
                },
              }"
              ><span class="mdi mdi-lead-pencil mr-1"></span>編輯
            </b-button> -->
            <b-button
              class="ml-2"
              variant="inverse-warning"
              v-if="isBranchProductList ? checkPermission([consts.BRANCH_PRODUCT_MODIFY]) : (checkPermission([consts.PRODUCT_MODIFY]) || checkPermission([consts.PRODUCT_STOCK_MODIFY]))"
              :to="{
                name: 'ProductEditV2',
                params: {
                  product_id: data.item.id
                },
                query: {
                  is_branch_product: isBranchProductList
                }
              }"
            ><span class="mdi mdi-lead-pencil mr-1"></span>編輯
            </b-button>
            <b-button
              class="ml-2"
              variant="inverse-danger"
              @click="handleDelete(data.item.id)"
              v-if="isBranchProductList ? checkPermission([consts.BRANCH_PRODUCT_DELETE]) : checkPermission([consts.PRODUCT_DELETE])"
              ><span class="mdi mdi-delete mr-1"></span>刪除
            </b-button>
            <b-dropdown variant="inverse-secondary" class="ml-2">
              <template slot="button-content">
                <i class="mdi mdi-menu"></i>
              </template>
              <b-dropdown-item
                class="ml-2"
                v-if="checkPermission([consts.PRODUCT_IMAGE_MODIFY])"
                :to="{
                name: 'ProductUpdateImage',
                params: {
                  product_id: data.item.id,
                },
              }"
              ><i class="mdi mdi-image-multiple"></i>設定圖片
              </b-dropdown-item>
              <b-dropdown-item
                v-if="!isBranchProductList && checkPermission([consts.BRANCH_PRODUCT_SYNC])"
                @click="handleSyncOneProductToBranch(data.item.id)"
              ><i class="mdi mdi-sync" aria-hidden="true"></i>同步至所有分店
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <CustomPagination
          :currentPage="query.page"
          :totalRows="totalRows"
          :perPage="query.per_page"
          @page-change="handlePageChange"
          @per-page-change="handlePerPageChange"
        />
      </b-overlay>
    </b-card>
    <b-modal
      id="modal-upload"
      title="批次上傳"
    >
      <b-overlay :show="showLoadingUpload">
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">選擇通路</label>
          <b-form-select
            v-model="query.merchant_id"
            :options="merchants"
            disabled
          ></b-form-select>
        </div>
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">
            請上傳帳號 Excel 檔案
          </label>
          <b-form-file plain @input="uploadProduct" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
        </div>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="
            getSampleExcelFile(
              null,
              '/excel/product_list.xlsx'
            )
          "
          ><i class="fa fa-file-text"></i
          >下載範例檔案</b-button
        >
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-upload-michelin"
      title="批次上傳 - 米其林"
    >
      <b-overlay :show="showLoadingUploadMichelin">
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">選擇通路</label>
          <b-form-select
            v-model="query.merchant_id"
            :options="merchants"
            disabled
          ></b-form-select>
        </div>
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">
            請上傳商品 Excel 檔案
          </label>
          <b-form-file ref="fileInputMichelin" plain @input="uploadProductMichelin" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
        </div>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-upload-michelin-mb"
      title="批次上傳 - 米其林 - MB"
    >
      <b-overlay :show="showLoadingUploadMichelinMb">
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">選擇通路</label>
          <b-form-select
            v-model="query.merchant_id"
            :options="merchants"
            disabled
          ></b-form-select>
        </div>
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">
            請上傳商品 Excel 檔案
          </label>
          <b-form-file ref="fileInputMichelinMb" plain @input="uploadProductMichelinMb" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
        </div>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import merchantApi from "../../../apis/merchant";
import productApi from "../../../apis/product";
import _ from "lodash"
import moment from "moment";
import PermissionChecker from "@/utils/PermissionChecker";
import * as consts from "@/consts";
import { updateQueryFromRoute, updateUrlWithoutReload } from "@/utils/updateUrl";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { mapState, mapActions } from "vuex";
import {paginationMixin} from "@/mixins/pagination";
import { getSampleExcelFile } from "@/utils/dashboardUtils";
import AppSingleSelect from "@/components/AppSingleSelect.vue";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  mixins: [paginationMixin],
  components: {AppSingleSelect, CustomPagination, BreadCrumb },
  data() {
    return {
      consts,
      showLoading: false,
      isAdvancedSearchVisible: false,
      showLoadingUpload: false,
      showLoadingUploadMichelin: false,
      showLoadingUploadMichelinMb: false,
      merchants: [{ value: null, text: "請選擇" }],
      totalRows: 0,
      fields: [
        {
          key: "name",
          label: "商品名稱/編號",
          tdClass: 'text-truncate-hover',
        },
        {
          key: "picture",
          label: "商品圖片",
        },
        {
          key: "price",
          label: "售價/原價",
        },
        {
          key: "started_at_and_end_at",
          label: "開始/結束販售時間",
        },
        {
          key: "type",
          label: "商品類型",
        },
        {
          key: "arrange",
          label: "管理",
        },
      ],
      products: [],
      permissionChecker: new PermissionChecker(),
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
        keyword: "",
        merchant_id: null,
        branch_id: null,
        type: null,
        category: '*',
        is_enabled: 1,
      },
      productTypes: [],
      productCategories: [],
      productStatusOptions: [
        { value: null, text: '全部' },
        { value: 1, text: '啟用中' },
        { value: 0, text: '已停用' },
      ],
      // https://github.com/Waltily-Inc/waltily-frontend/issues/3473
      // 「分店商品列表」 與 「一般商品列表」 共用 ProductList.vue
      // 因此需要一個變數來判斷是否為「分店商品列表」
      isBranchProductList: false, // 是否為「分店商品列表」
      selectedBranch: null,
    };
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrlWithoutReload(this.query, this.$store, this.$router);
        this.fetchProducts();
      },
    },
  },
  computed: {
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
    ...mapState("general", {
      defaultMerchantType: (state) => state.defaultMerchantType,
      myBranches: state => state.myBranches,
      currentBranch: state => state.currentBranch,
    }, ["currentBranch"]),
    productCategoryOptions() {
      return [
        { value: '*', text: '全部分類' },
        { value: 'null', text: '未分類' },
        ...this.productCategories.map(category => ({ value: category, text: category }))
      ]
    },
    canViewBranchProductList() {
      return this.checkPermission([consts.BRANCH_PRODUCT_LIST_VIEW]);
    },
    canViewNoBranchProductList() {
      return this.checkPermission([consts.BRANCH_PRODUCT_LIST_VIEW_NO_BRANCH]);
    },
    isBranchSelectDisabled() {
      return this.isBranchProductList && this.canViewNoBranchProductList && !this.canViewBranchProductList;
    },
    branchOptions() {
      const options = [];

      if (this.isBranchProductList && this.canViewNoBranchProductList) {
        options.push({
          value: "null",
          text: "品牌組織階層(無隸屬分店)",
        });
      }

      if (!this.isBranchProductList || this.canViewBranchProductList || options.length === 0) {
        options.push(
          ...this.myBranches.map(branch => {
            let branchName = `${branch.branch_code} ${branch.name}`
            return {
              value: branch.id,
              text: branchName
            }
          })
        );
      }

      return options;
    },
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
    this.isBranchProductList = this.$route.name === 'BranchProductList';
    if (this.isBranchProductList) {
      this.selectedBranch = this.branchOptions.find(branch => branch.value === this.query.branch_id)
    }
  },
  async mounted() {
    if (this.isBranchProductList) {
      if (this.query.branch_id === null || this.query.branch_id === undefined) {
        if (this.currentBranch) {
          this.selectedBranch = this.branchOptions.find(branch => branch.value === this.currentBranch.id);
        } else if (this.canViewNoBranchProductList) {
          this.selectedBranch = this.branchOptions.find(branch => branch.value === "null");
        }
      } else {
        this.selectedBranch = this.branchOptions.find(branch => branch.value === this.query.branch_id);
      }

      this.query.branch_id = this.selectedBranch?.value ?? null;
    }

    await Promise.all([
      this.fetchMerchants(),
      this.fetchProductTypes(),
      this.fetchProductCategories(),
      this.fetchProducts()
    ])
    this.initialized = true;
  },
  methods: {
    getSampleExcelFile,
    async uploadProductMichelinMb(file) {
      if (!file) return;

      this.showLoadingUploadMichelinMb = true;
      let formData = new FormData();
      formData.append("file", file);
      formData.append("merchant_id", this.query.merchant_id);
      formData.append("branch_id", this.query.branch_id || null);
      try {
        let response = await productApi.uploadProductMichelin(formData, "michelin_mb");

        if (response.status === 200 && response.data.status === "success") {
          this.$swal.fire({
            title: "上傳成功",
            type: "success",
          });

          this.fetchProducts()
        }
      } catch (e) {
        console.error(e);
        if (e.response && e.response.status === 422 && e.response.data.errors) {
          const errors = e.response.data.errors;
          const firstKey = Object.keys(errors)[0];
          const errorMsg = `第 ${Number(firstKey) + 2} 列：${errors[firstKey][0]}`;

          this.$swal.fire({
            title: "檔案內容有誤",
            type: "error",
            text: errorMsg,
          });
        } else if (e.response && e.response.status === 403) {
          this.$swal.fire({
            title: "權限不足",
            type: "error",
            text: e.response.data.message || "此功能僅限 米其林 MB 組織使用",
          });
        } else if (e.response && e.response.status === 400) {
          this.$swal.fire({
            title: "請求無效",
            type: "error",
            text: e.response.data.message || "找不到對應的通路",
          });
        } else if (e.response && e.response.status === 500) {
          this.$swal.fire({
            title: "系統錯誤",
            type: "error",
            text: e.response.data.message || "米其林商品匯入失敗",
          });
        } else {
          this.$swal.fire({
            title: "上傳失敗",
            type: "error",
          });
        }
      } finally {
        this.showLoadingUploadMichelinMb = false;
        if (this.$refs.fileInputMichelinMb) {
          this.$refs.fileInputMichelinMb.reset();
        }
        this.$bvModal.hide("modal-upload-michelin-mb");
      }
    },
    async uploadProductMichelin(file) {
      if (!file) return;

      this.$swal
        .fire({
          type: "warning",
          title: "確定執行此動作後，將刪除舊有資料，用新檔案取代",
          showCancelButton: true,
          confirmButtonText: "確定",
          cancelButtonText: "取消",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value || result.isConfirmed) {
            this.showLoadingUploadMichelin = true;
            let formData = new FormData();
            formData.append("file", file);
            formData.append("merchant_id", this.query.merchant_id);
            formData.append("branch_id", this.query.branch_id || null);
            try {
              let response = await productApi.uploadProductMichelin(formData);

              if (response.status === 200 && response.data.status === "success") {
                this.$swal.fire({
                  title: "上傳成功",
                  type: "success",
                });

                this.fetchProducts()
              }
            } catch (e) {
              console.error(e);
              if (e.response && e.response.status === 422 && e.response.data.errors) {
                const errors = e.response.data.errors;
                const firstKey = Object.keys(errors)[0];
                const errorMsg = `第 ${Number(firstKey) + 2} 列：${errors[firstKey][0]}`;

                this.$swal.fire({
                  title: "檔案內容有誤",
                  type: "error",
                  text: errorMsg,
                });
              } else if (e.response && e.response.status === 403) {
                this.$swal.fire({
                  title: "權限不足",
                  type: "error",
                  text: e.response.data.message || "此功能僅限 米其林 組織使用",
                });
              } else if (e.response && e.response.status === 400) {
                this.$swal.fire({
                  title: "請求無效",
                  type: "error",
                  text: e.response.data.message || "找不到對應的通路",
                });
              } else if (e.response && e.response.status === 500) {
                this.$swal.fire({
                  title: "系統錯誤",
                  type: "error",
                  text: e.response.data.message || "米其林商品匯入失敗",
                });
              } else {
                this.$swal.fire({
                  title: "上傳失敗",
                  type: "error",
                });
              }
            } finally {
              this.showLoadingUploadMichelin = false;
              if (this.$refs.fileInputMichelin) {
                this.$refs.fileInputMichelin.reset();
              }
              this.$bvModal.hide("modal-upload-michelin");
            }
          } else {
            if (this.$refs.fileInputMichelin) {
              this.$refs.fileInputMichelin.reset();
            }
          }
        });
    },
    async uploadProduct(file) {
      this.showLoadingUpload = true;
      let formData = new FormData();
      formData.append("file", file);
      formData.append("merchant_id", this.query.merchant_id);
      formData.append("branch_id", this.query.branch_id || null);
      try {
        let response = await productApi.uploadProduct(formData);

        if (response.status === 200 && response.data.status === "success") {
          this.$swal.fire({
            title: "上傳成功",
            type: "success",
          });

          this.fetchProducts()
        }
      } catch (e) {
        console.error(e);
        if (e.response.status === 422 && e.response.data.message[0]) {
          this.$swal.fire({
            title: "檔案內容有誤",
            type: "error",
            text: e.response.data.message[0] ?? null,
          });
        } else {
          this.$swal.fire({
            title: "上傳失敗",
            type: "error",
          });
        }
      } finally {
        this.showLoadingUpload = false;
        this.$bvModal.hide("modal-upload");
      }
    },
    async fetchProducts() {
      if (!this.query.merchant_id) return;

      // 多下一層保護，避免在「商品管理」中，因為左側的分店下拉選單更新導致 branch_id 被帶入特定值查詢
      if (!this.isBranchProductList) {
        this.query.branch_id = null;
      } else {
        const hasNoBranchPermission = this.canViewNoBranchProductList;
        const branchId = this.normalizeBranchIdForPayload(this.query.branch_id);

        // 在「分店商品列表」中，若未選擇分店且無組織層級權限，則不進行查詢
        if (!hasNoBranchPermission && !branchId) return;
      }
      this.showLoading = true;

      try {
        const params = {
          ...this.query,
        };
        if (this.isBranchProductList) {
          params.branch_id = this.normalizeBranchIdForPayload(params.branch_id);
        }
        if (this.query.category === '*') {
          delete params.category
        }

        let response = await productApi.getProducts(params);

        const { data } = response;

        this.products = data.data;
        this.totalRows = data.meta.total;
      } catch (error) {
        console.error(error);
        alert("取得商品資料錯誤");
      }
      this.showLoading = false;
    },
    async fetchMerchants() {
      const { data } = await merchantApi.list();

      this.merchants = [
        { value: null, text: "請選擇" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            text: `${merchant.name} (${merchant.type_name})`,
          };
        }),
      ];

      let defaultMerchant = this.findDefaultMerchant(data.data);

      if (defaultMerchant) {
        this.query.merchant_id = defaultMerchant.id;
        await this.fetchProducts();
      }
    },
    findDefaultMerchant(merchants) {
      let defaultMerchant;

      if (this.$route.query.merchant_id) {
        defaultMerchant = merchants.find((merchant) => {
          return merchant.id === this.$route.query.merchant_id;
        });

        if (!defaultMerchant) {
          this.$swal.fire({
            type: "warning",
            title: "查無此通路",
            confirmButtonText: "確定",
            confirmButtonColor: "#d33",
            reverseButtons: true,
          });
          return;
        }
      } else if (merchants.length == 1) {
        defaultMerchant = merchants[0];
      } else {
        defaultMerchant =
          merchants.find(
            (merchant) => merchant.type === this.defaultMerchantType
          ) ?? merchants.find((merchant) => merchant.type === consts.MERCHANT_TYPES.LINE_TYPE);
      }

      return defaultMerchant;
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD HH:mm");
      }
    },
    async handleDelete(id) {
      this.$swal
        .fire({
          type: "warning",
          title: "你確定要刪除嗎？",
          confirmButtonText: "確定刪除",
          cancelButtonText: "不刪除",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            try {
              const response = await productApi.deleteProduct(id);
              if (response.status === 200) {
                await this.$swal.fire({
                  title: "成功",
                  type: "success",
                  text: "刪除成功",
                });
                await this.fetchProducts();
              }
            } catch (error) {
              this.$swal("失敗", error.response.data.message, "error");
            }
          }
        });
    },
    checkPermission(permissions) {
      return this.permissionChecker.check(permissions);
    },
    async handleSyncAllBranchProduct() {
      if (this.isBranchProductList) return;
       this.$swal
         .fire({
           type: "warning",
           title: "你確定要同步所有分店商品嗎？",
           confirmButtonText: "確定",
           cancelButtonText: "取消",
           showCancelButton: true,
           reverseButtons: true,
         })
         .then(async (result) => {
           if (result.value) {
             try {
               const response = await productApi.syncBranchProducts();
               if (response.status === 200) {
                 await this.$swal.fire({
                   title: "成功",
                   type: "success",
                   text: "同步已開始進行",
                 });
                 await this.fetchProducts();
               }
             } catch (error) {
               this.$swal("失敗", error.response.data.message, "同步觸發失敗。同步可能正在進行中，請稍候再試");
             }
           }
         });
    },
    async handleSyncOneProductToBranch(productId) {
      if (this.isBranchProductList) return;
      this.$swal
        .fire({
          type: "warning",
          title: "你確定要同步此商品至所有分店嗎？",
          confirmButtonText: "確定",
          cancelButtonText: "取消",
          showCancelButton: true,
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            try {
              const response = await productApi.syncBranchProducts({ product_id: productId });
              if (response.status === 200) {
                await this.$swal.fire({
                  title: "成功",
                  type: "success",
                  text: "同步已開始進行",
                });
                await this.fetchProducts();
              }
            } catch (error) {
              this.$swal("失敗", error.response.data.message, "同步觸發失敗。同步可能正在進行中，請稍候再試");
            }
          }
        });
    },
    async handleSyncProductFromMain() {
      if (!this.isBranchProductList) return;
      if (!this.selectedBranch) {
        this.$swal.fire({
          type: "warning",
          title: "請選擇分店",
          confirmButtonText: "確定",
        });
        return;
      }
      if (this.selectedBranch.value === "null") {
        this.$swal.fire({
          type: "warning",
          title: "品牌組織階層不支援此同步功能",
          confirmButtonText: "確定",
        });
        return;
      }
      const branch = this.branchOptions.find((branch) => branch.value === this.selectedBranch.value);
      this.$swal
        .fire({
          type: "warning",
          title: "確定將商品同步一份至" + branch.text + "嗎？",
          confirmButtonText: "確定同步",
          cancelButtonText: "取消",
          showCancelButton: true,
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            try {
              const response = await productApi.syncBranchProducts({'branch_id': branch.value});
              if (response.status === 200) {
                await this.$swal.fire({
                  title: "成功",
                  type: "success",
                  text: "同步已開始進行",
                });
                await this.fetchProducts();
              }
            } catch (error) {
              this.$swal("失敗", error.response.data.message, "同步觸發失敗。同步可能正在進行中，請稍候再試");
            }
          }
        });
    },
    async fetchProductTypes() {
      try {
        const { data } = await productApi.getProductTypes();
        this.productTypes = data.data.map(type => ({ value: type.value, text: type.text }));
      } catch (error) {
        console.error(error);
        alert("取得商品類型錯誤");
      }
    },
    async fetchProductCategories() {
      try {
        this.productCategories = _.get(await productApi.getProductCategories(), 'data.data', []);
      } catch (error) {
        console.error(error);
        alert("取得商品分類錯誤");
      }
    },
    getProductTypeText(type) {
      const productType = this.productTypes.find(pt => pt.value === type);
      return productType ? productType.text : type;
    },
    ...mapActions("general", ["setCurrentBranch"]),

    handleBranchChange() {
      this.query.branch_id = this.selectedBranch?.value ?? null;

      this.handleFiltersAreChanged();
    },
    syncBranchFilterToQuery() {
      if (this.isBranchProductList) {
        this.query.branch_id = this.selectedBranch?.value ?? null;
      } else {
        this.query.branch_id = null;
      }
    },
    normalizeBranchIdForPayload(branchId) {
      return branchId === "null" ? null : branchId;
    },
    handleSearchFromAdvanced() {
      this.handleFiltersAreChanged();
    },
    resetAdvancedSearch() {
      if (this.isBranchProductList) {
        if (this.currentBranch && this.canViewBranchProductList) {
          this.selectedBranch = this.branchOptions.find(branch => branch.value === this.currentBranch.id) ?? this.branchOptions[0] ?? null;
        } else if (this.canViewNoBranchProductList) {
          this.selectedBranch = this.branchOptions.find(branch => branch.value === "null") ?? this.branchOptions[0] ?? null;
        } else {
          this.selectedBranch = this.branchOptions[0] ?? null;
        }
        this.query.branch_id = this.selectedBranch?.value ?? null;
      } else {
        this.query.branch_id = null;
      }

      this.query.type = null;
      this.query.category = "*";
      this.query.is_enabled = 1;

      if (this.merchants.length === 2) {
        const defaultMerchant = this.merchants.find((merchant) => merchant.value !== null);
        this.query.merchant_id = defaultMerchant?.value ?? null;
      } else {
        this.query.merchant_id = null;
      }

      this.handleSearchFromAdvanced();
    },
    handleFiltersAreChanged() {
      this.syncBranchFilterToQuery();
      this.fetchProducts()
      this.handlePageResetWithoutReload()
    },
    hiddenString(value, length) {
      value = value || "";
      const splittedValue = [...value];
      if (splittedValue.length <= length) {
        return value;
      }
      return splittedValue.slice(0, length).join("") + "...";
    },
  }
};
</script>

<style scoped>
.modal-backdrop {
  opacity: 0.5;
}

/* 確保表格可以正確處理截斷 */
.product-list-table {
  table-layout: auto;
}

/* 文字截斷儲存格 - 用於 div/span 元素 */
.product-list-table >>> .text-truncate-cell {
  display: block;
  max-width: 460px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 針對 tdClass 的文字截斷，保留固定最大寬度 */
.product-list-table >>> .text-truncate-hover {
  max-width: 460px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.advanced-search-control {
  height: 36px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.filter-label {
  min-width: 56px;
}
</style>
